$(function () {
  $(".shopify-section--main-article .rte a").each(function(){
    var articleHref = $(this).attr("href").split('/')[2];
    if(articleHref != window.location.host){
      $(this).attr("rel","nofollow");
    };
  });
});

$(document).ready(function() {
  if($(".article__author").length != 0){
    let article_author_text = $(".article__author").text();
    console.log(article_author_text);
    
    $('.article__content .rte').find('ul').eq(0).empty();
      $('.article__content .rte h2').each(function(index) {
        $(this).attr('id', 'section-' + (index+1));
    
        var link = $('<a>').attr('href', '#section-' + (index+1)).text($(this).text());
    
        var listItem = $('<li>').append(link);
        $('.article__content .rte').find('ul').eq(0).append(listItem);
    
        link.click(function(e) {
          e.preventDefault();
          var target = $(this.hash);
          $('html, body').animate({
            scrollTop: target.offset().top - 100
          }, 1000);
        });
      });
  }
});